import React from 'react';
import { Toaster } from 'react-hot-toast';

const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <>
      {children}
      <Toaster
        position="top-right"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          // Default options
          duration: 4000,
          style: {
            background: '#fff',
            color: '#363636',
            boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
            borderRadius: '12px',
            padding: '16px',
            fontSize: '14px',
            maxWidth: '500px',
          },
          // Success style
          success: {
            duration: 3000,
            style: {
              background: '#dcfce7',
              color: '#166534',
            },
            iconTheme: {
              primary: '#22c55e',
              secondary: '#dcfce7',
            },
          },
          // Error style
          error: {
            duration: 5000,
            style: {
              background: '#fee2e2',
              color: '#991b1b',
            },
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fee2e2',
            },
          },
          // Loading style
          loading: {
            style: {
              background: '#e0f2fe',
              color: '#075985',
            },
            iconTheme: {
              primary: '#0ea5e9',
              secondary: '#e0f2fe',
            },
          },
        }}
      />
    </>
  );
};

export default ToastProvider;
